module.exports = __webpack_public_path__ + "static/media/DIC_logo.06e0f3ba.jpg";